export enum OfferRecommendationType {
    CHEAPEST = 'CHEAPEST',
    BASIC_OC = 'BASIC_OC',
    BASIC_AC = 'BASIC_AC',
    OPTIMUM_OC = 'OPTIMUM_OC',
    OPTIMUM_AC = 'OPTIMUM_AC',
    FULL = 'FULL',
}

export enum OfferRecommendationRole {
    CHEAPEST = 'CHEAPEST',
    POPULAR = 'POPULAR',
    FOR_DEMANDING = 'FOR_DEMANDING',
}
